import { Outlet } from "react-router-dom";

export default function ManufacturerLayout() {
  return (
    <Outlet />
  )
}